<router-outlet *ngIf="isReady"></router-outlet>
